/**
 * Gestisce l'esecuzione della view corretta a seconda della pagina in cui ci si trova
 */
export default class NwRouter {
    constructor() {
        this.currentRoute = null;
    }

    /**
     * Configura l'oggetto router
     * @param views (Object): Oggetto di tutte le viste disponibili con la struttura:
     *  {
     *      'nome_view': funzione_view
     *  }
     * @param defaultView (string): Nome della view predefinita da utilizzare nel caso non sia disponibile
     *                              una personalizzata per la pagina corrente
     * @param beforeStart (null|function): Funzione da richiamare prima dell'avvio della view (es. per eseguire configurazione condivise fra più pagine)
     */
    configure(views, defaultView='page_general', beforeStart=null) {
        if (!defaultView in views) {
            throw new Error('Default view non valida: ' + this.defaultView);
        }

        this.views = views;
        this.defaultView = defaultView;
        this.beforeStart = beforeStart;
        this._isConfigured = true;
    }

    /**
     * Avvia l'esecuzione della corretta view a seconda dei parametri indicati
     *  @param app (NwApp): Oggetto applicazione
     *  @param pageView (string): Nome della view usata nella pagina (es. 'page_news')
     *  @param singleView (string): Nome della view usata per i singolo articoli della pagina (es. 'page_news_single')
     *  @param isArticle (bool): True se la pagina corrente è un articolo singolo.
     */
    start(app, pageView, singleView, isArticle) {
        if (!this._isConfigured)
            throw new Error('Router non configurato');

        var viewName;
        if (isArticle && singleView in this.views) {
            viewName = singleView;
        }else if (pageView in this.views) {
            viewName = pageView;
        }else {
            viewName = this.defaultView;
        }

        this.currentRoute = new NwRoute(pageView, singleView, isArticle);

        if (typeof this.beforeStart === 'function') {
            this.beforeStart.call(app, app);
        }
        this.views[viewName].call(app, app);

        if (app.debug) {
            console.log('[NWROUTER] Route: ', this.currentRoute);
            console.log('[NWROUTER] Current view: ' + viewName);
        }
    }
}


/**
 * Informazioni su una route
 */
class NwRoute {
    constructor(pageView, singleView, isArticle) {
        this.pageView = pageView;
        this.singleView = singleView;
        this.isArticle = isArticle;
    }
}


/** WEBPACK FOOTER **
 ** ./assets/scripts/src/core/router.js
 **/